var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const subscribeToNewsletter = (email) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        // Call the Netlify function that integrates with Brevo
        const response = yield fetch('/.netlify/functions/subscribe', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
        });
        const data = yield response.json();
        if (!response.ok) {
            throw new Error(data.error || 'Failed to subscribe to newsletter');
        }
        return data;
    }
    catch (error) {
        console.error('Newsletter subscription error:', error);
        throw error;
    }
});
